import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    List,
    InputBase,
    Switch,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    Dialog,
    DialogContent,
    InputAdornment,
    Button,
    DialogTitle,
    TextField,
    SvgIcon,
    Tooltip,
    Paper,
    FormLabel,
    RadioGroup,
    Radio,
    Checkbox,
    FormControlLabel
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux'
import * as Actions from "./store/actions"
import * as ib from "./ibdata"
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import ReactGA from 'react-ga';
import CloseIcon from '@material-ui/icons/Close';
import TimerOffIcon from '@material-ui/icons/TimerOff';
import LockIcon from '@material-ui/icons/Lock';
import CancelIcon from '@material-ui/icons/Cancel';
import ShowCaseDialog from './ShowCaseDialog';
import * as mylocalStorage from "./mylocalStorage";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import CorrectIcon from "./correctIcon.svg";
import Divider from '@material-ui/core/Divider';
import "./styles/drawerWalker.css";
import { composeComponentAs } from '@uifabric/utilities';
import { OpenInBrowser } from '@material-ui/icons';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import clsx from 'clsx';

var gProcess = {}
var gPage1Sess = {}

const useStyles = makeStyles((theme) => ({
    root: {
        width: 500,
    },
    inviteButton: {
        border: "1px solid #C8CEDA",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgba(0, 35, 61, 0.04)",
        borderRadius: "999px",
        fontSize: "0.5rem",
        fontFamily: 'Poppins',
        fontWeight: 'normal',
        textTransform: "none",
        display: 'inline-flex',
        margin: "5px",
        padding: "5px",
        padding: "12px 22.5px",
        "&:hover": {
            cursor: "pointer",
        },
    },
    list: {
        padding: "0px",
    },
    listItemText: {
        fontSize: "16px",
        fontFamily: 'lato',
        fontWeight: 'normal',
        color: "#2F3D5B",
    },
    paper: {
        borderRadius: "8px",
        maxHeight: "56vh",
        width: "350px",
        overflow: "auto",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
    },
    typography: {
        padding: theme.spacing(2),
    },
    buttonReset: {
        fontSize: "0.5rem",
        fontFamily: 'Poppins',
        fontWeight: 'normal',
        color: '#ffffff',
        margin: "0 auto",
        padding: "0",
        width: "100%",
        borderRadius: '5px',
        "&:hover": {
            color: "#2F3D5B",
        },
    },
    tooltip: {
        margin: "4px 0",
    },
    customTooltip: {
        // I used the rgba color for the standard "secondary" color
        backgroundColor: "#1E2639",
        fontSize: "0.8rem",
        fontFamily: 'Poppins',
        fontWeight: 'normal',
    },
    customArrow: {
        color: "#1E2639",
    },
    dots: {
        color: "#7D8FB6",
        position: "relative",
        top: "-5px",
        "&:hover": {
            color: "#3174F5",
            cursor: "move",
        },
    },
    headerDots: {
        width:"100%",
        height:"7px",
        display: "flex",
        justifyContent: "space-around",
        backgroundColor: "#E2E6E9",
    },
    disableAll: {
        color: "#FFFFFF",
        fontSize: "16px",
        margin: "10px 20px",
        display: "flex",
        justifyContent: "space-around",
        cursor: "pointer",
        border: "1px solid #E0E5E7",
        borderRadius: "999px",
        width: "110px",
        padding: "6px 12px",
        float: "right",
        textTransform: "capitalize",
        "&:hover": {
            color: '#2F3D5B',
        }
    },
}));

function AlarmIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" /></svg>
        </SvgIcon>
    )
}

function ClassTimer(props) {
    const classes = useStyles();
    const boardConfig = useSelector((state) => state.BoardConfig);
    const teacherR = useSelector((state) => state.teacher);
    const timer = useSelector((state) => state.timer);
    const boardLocked = useSelector((state) => state.boardLocked);
    const pageLocked = useSelector((state) => state.pageLocked);

    const followTeacher = useSelector((state) => state.followTeacher);
    const showCase = useSelector((state) => state.showCase);
    const clockDrift = useSelector((state) => state.clockDrift);

    const dispatch = useDispatch();
    const tpopperRef = React.useRef(null)
    const popRef = React.useRef(null)
    const [diag, setDiag] = React.useState({ open: false, cb: null })
    const [clock, setClock] = React.useState({ timeout: false, timeLeft: "", end: "" });
    const [open, _setOpen] = React.useState(false)
    const [alarmRing, setAlarmRing] = React.useState(false);
    const hideNotification = useSelector((state) => state.hideNotification);
    const [elTop, setElTop] = React.useState('0px');
    const [elLeft, setElLeft] = React.useState('0px');
    const [stopTimerDebounce, setStopTimerDebounce] = React.useState(false);
    const [pinned, setPinned] = React.useState(false)
    const [timerEl, setTimerEl] = React.useState(null)
    const [lastDuration, setLastDuration] = React.useState("")
    const [lengthOfNotifications, setLengthOfNotifications] = React.useState(0)
    var alarmWasSet = false;
    // const handleClick = (newPlacement) => (event) => {
    //     setAnchorEl(event.currentTarget);
    //     setOpen((prev) => placement !== newPlacement || !prev);
    //     setPlacement(newPlacement);
    // };
    const teacherStyle = {
        color: "#3174F5",
        padding: "2px 10px",
        margin: "2px",
        fontSize: "14px",
        fontFamily: 'Lato',
        fontWeight: 'normal',
        textTransform: "none",
        display: 'inline-flex',
        background: "linear-gradient(180deg, #FFFFFF 0%, #F4F5F6 100%)",
        border: "1px solid #C8CEDA",
        borderRadius: "999px",
        boxShadow: "0px 1px 2px rgba(0, 35, 61, 0.04)",
    };
    function setOpen(o) {
        if (o === true) {
            setTimerEl(p => {
                var el = document.getElementById('transitions-popper');
                if (el) {
                    console.error("setting dragelement");
                    dragElement(el);
                }
                return el;
            })
        }
        _setOpen(o)
    }

    React.useEffect(() => {
        dispatch(Actions.setTimerEvent(null))
    }, [props.sess])

    async function soundAlarm() {
        var playAudio = true;
        var snd = new Audio("data:audio/wav;base64,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");
        await new Promise(r => setTimeout(r, 1200));
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                try {
                    if (playAudio)
                        await snd.play();
                } catch (err) {
                    playAudio = false
                    ReactGA.event({
                        category: "Timer",
                        action: "Sound disallowed"
                    });
                }
                await new Promise(r => setTimeout(r, 320));
            }
            await new Promise(r => setTimeout(r, 1200));
        }
    }

    const timerOffsetX = 0;
    const timerOffsetY = 100;
    React.useEffect(() => {
        setTimeout(() => {
            setTimerEl(p => {
                var el = document.getElementById('transitions-popper');
                if (el) {
                    dragElement(el);
                }
                /* If popRef is available, but position is not set, anchor it to the timer icon */
                if (popRef.current) {
                    if (elTop === '0px' && elLeft === '0px') {
                        var alIcon = document.getElementById('AlarmIcon');
                        if (alIcon) {
                            var r = alIcon.getBoundingClientRect()
                            popRef.current.style.top = r.top;
                            popRef.current.style.left = r.left;
                        }
                    } else {
                        popRef.current.style.top = elTop;
                        popRef.current.style.left = elLeft;
                    }
                }
                return el;
            })
        }, 100)
    }, [popRef.current, hideNotification, boardLocked, followTeacher, clockDrift, pageLocked])

    React.useEffect(() => {
        const timerLocationStr = mylocalStorage.getItem("timerLocation");
        if (timerLocationStr && timerLocationStr !== undefined) {
            const timerLocation = JSON.parse(timerLocationStr);
            if (timerLocation && timerLocation.top && timerLocation.left) {
                setElTop(p => timerLocation.top);
                setElLeft(p => timerLocation.left);
            }
        }
        var savedDuration = mylocalStorage.getItem('lastTimerDuration');
        if (savedDuration)
            setLastDuration(p => savedDuration)
    }, [])

    React.useEffect(() => {
        if (alarmRing) {
            setTimeout(() => { setAlarmRing(p => false); }, 10000)
            soundAlarm()
        }
    }, [alarmRing])

    React.useEffect(() => {
        var myClock;
        if (!timer.running) {
            if (myClock) clearInterval(myClock);
            return
        }
        if (myClock) clearInterval(myClock);
        myClock = setInterval(myTimer, 1000)
        if (alarmRing) { setAlarmRing(p => false) }

        return (() => {
            if (myClock) clearInterval(myClock);
        })
        function pad2(number) {
            return (number < 10 ? '0' : '') + number
        }
        function myTimer() {
            if (timer && timer.events && timer.events.length > 0) {
                const c = timer.events[0]
                var start = new Date(c.updatedAt)
                if (c && c.Content && c.Content.kind) {
                    if (c.Content.kind.kind === "perStudent") {
                        if (c.id in gPage1Sess) {
                            var s = gPage1Sess[c.id]
                            start = new Date(s.createdAt)
                        } else {
                            const pgSplit = props.sess.id.split("-pgNum-")
                            ib.getSession(pgSplit[0] + "-pgNum-1").then((res) => {
                                var pg1 = res.data.getSession
                                if (pg1) {
                                    gPage1Sess[c.id] = pg1
                                }
                            })
                            return
                        }

                    }
                }
                var cd = new Date(start.getTime() + c.Content.Duration * 60000)
                var ce = new Date()
                var delta = (cd - ce) / 1000
                delta = delta + clockDrift

                if (delta <= 0) {
                    if (c && c.Content && c.Content.kind) {
                        if (c.Content.kind.autolock) {
                            if (c.id in gProcess) {
                                // already processed 
                            } else {

                                var classLock = true
                                if (c.Content.kind.kind === "perStudent") classLock = false
                                if (!classLock && props.sess.parentID === props.sess.Classroom) {

                                } else {
                                    ib.lockClass(props.sess, "LockClass", true, classLock)
                                }
                                gProcess[c.id] = true
                            }
                        }
                    }
                    setClock(p => {
                        // the alarmWasSet check avoids alarm from going off again if the timer is
                        // already 0 and if the page is reloaded or someone visits the board again.
                        if (alarmWasSet) setAlarmRing(true);
                        clearInterval(myClock);
                        return { timeLeft: "00:00:00", end: cd.toLocaleTimeString(), timeout: true }
                    })
                    return
                }

                var hours = Math.floor(delta / 3600);
                delta -= hours * 3600;
                var minutes = Math.floor(delta / 60) % 60;
                delta -= minutes * 60;
                var seconds = Math.floor(delta % 60)
                alarmWasSet = true

                var formated1 = pad2(hours) + ":" + pad2(minutes) + ":" + pad2(seconds)//moment().duration(elapsedDuration).format("HH:MM:SS");
                setClock({ timeLeft: formated1, end: cd.toLocaleTimeString(), timeout: false })
            }
        }
    }, [timer, timer.events, clockDrift])

    function unFollowTeacher() {
        if (!teacherR) return
        ReactGA.event({
            category: "unFollowTeacher",
            action: "UnLock"
        });
        var copy = JSON.parse(JSON.stringify(followTeacher.events[0]))
        delete copy['Content']
        copy['State'] = "Done"
        ib.updateClassroomEvent(copy)
    }
    function unLockClass() {
        if (!teacherR) return
        ReactGA.event({
            category: "LockClass",
            action: "UnLock"
        });
        var copy = JSON.parse(JSON.stringify(boardLocked.events[0]))
        delete copy['Content']
        copy['State'] = "Done"
        ib.updateClassroomEvent(copy)
    }
    function unLockPage() {
        if (!teacherR) return
        ReactGA.event({
            category: "UnLockPage",
            action: "UnLock"
        });
        var ff = pageLocked.myev
        if (pageLocked.locked && ff) {
            var copy = JSON.parse(JSON.stringify(ff))
            delete copy['Content']
            copy['State'] = "Done"
            ib.updateClassroomEvent(copy)
        }
    }
    function showcaseRemove() {
        if (!teacherR) return
        ReactGA.event({
            category: "ShowCase",
            action: "UnLock"
        });
        showCase.events.forEach((e) => {
            var copy = JSON.parse(JSON.stringify(e))
            delete copy['Content']
            copy['State'] = "Done"
            ib.updateClassroomEvent(copy)
        })
    }
    function stopTimer(e) {
        var debouncing = false;
        setStopTimerDebounce(p => { debouncing = p; return p });
        if (debouncing) return;
        ReactGA.event({
            category: "Timer",
            action: "StopTimer"
        });
        var copy = JSON.parse(JSON.stringify(e))
        delete copy['Content']
        copy['State'] = "Done"
        ib.updateClassroomEvent(copy)
    }

    function resetHourGlass(e) {
        var debouncing = false;
        setStopTimerDebounce(p => { debouncing = p; return p });
        if (debouncing) return;
        ReactGA.event({
            category: "Timer",
            action: "Reset HourGlass"
        });
        var copy = JSON.parse(JSON.stringify(e))
        delete copy['Content']
        copy['State'] = "Sent"
        delete copy['updatedAt']
        ib.updateClassroomEvent(copy)
    }
    function GetTime() {
        const [name, setName] = React.useState("")
        const [msg, setMsg] = React.useState(null)

        function OnChangeName(evt) {
            var m = evt.target.value 
            if (m.includes(";")) {
                let f = m.split(";")
                setName(f[0].trim())
                setMsg(f[1].trim())
            } else {
                setMsg(null)
                setName(m)
            }
        }
        const handleClose = () => {
            var kind = { kind: value, autolock: state.autoLock }
            if (diag.cb) diag.cb(name, kind, msg)
            setDiag({ open: false, cb: null });
        };
        function setNameButton(e) {
            if (e) e.preventDefault()
            setLastDuration(p => name)
            mylocalStorage.setItem('lastTimerDuration', name);
            var kind = { kind: value, autolock: state.autoLock }
            if (diag.cb) diag.cb(name, kind, msg)
        }
        const [value, setValue] = React.useState('instant');
        const [state, setState] = React.useState({
            autoLock: false
        })
        const handleChange2 = (event) => {
            // setState({ ...state, [event.target.name]: event.target.checked });
            setState({ autoLock: event.target.checked })
        };
        const handleChange = (event) => {
            setValue(event.target.value);
        };
        function handleTime(e) {
            //convert to mins from now
            var today = new Date();
            var diff = Math.abs(new Date(e.target.value) - today)
            var minutes = Math.floor((diff / 1000) / 60);
            setName(minutes + "")
            setMsg(null)
        }
        return (
            <Dialog
                open={diag.open}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className='nameDialog'
            >
                <div className='headerbg'>
                    <DialogTitle id="alert-dialog-slide-title" className='dialogTitle'>
                        Select a new timer
                        </DialogTitle>
                    <CloseIcon style={{
                        backgroundColor: "#E9EBF0", color: "rgb(47, 61, 91)", cursor: "pointer", borderRadius: "50%", position: "absolute", right: "35px", top: "18px",
                    }} onClick={handleClose} />
                </div>
                <DialogContent>

                    <div className=''>
                        <form onSubmit={setNameButton}>
                            {!diag.childOnGroup && (
                                <>
                                    <div className="formRadio">
                                    <RadioGroup aria-label="timerType" name="timerType" value={value} onChange={handleChange}>
                                        <FormControlLabel value="instant" control={<Radio />} label="Instant start for all participants" />
                                        <FormControlLabel value="atTime" control={<Radio />} label="Expires at time" />
                                        <FormControlLabel value="perStudent" control={<Radio />} label="Per Student (on Join)" />
                                    </RadioGroup>
                                    </div>
                                </>
                            )}
                            <div className="timerSetting">
                            {value === "atTime" && (
                                    <input id="party" className="datapicker" type="datetime-local" name="partydate"
                                    onChange={handleTime} />
                            )}
                            {value === "instant" && (
                                    <InputBase
                                    className="flex nameEnter"
                                    placeholder='Time in minutes [optional: ; comment]'
                                    onChange={(ev) => OnChangeName(ev)}
                                    autoFocus

                                />
                            )}
                            {value === "perStudent" && (
                                    <InputBase
                                    className="flex nameEnter"
                                    placeholder='Time in minutes (starts when student joins)'
                                    onChange={(ev) => OnChangeName(ev)}
                                    autoFocus
                                />
                            )}
                                <input
                                    style={{ backgroundColor: props.inkColor }}
                                    type="button"
                                    value="Set Timer"
                                    onClick={() => setNameButton()}
                                    disabled={name.length === 0}
                                    className={classes.inviteButton}
                                />
                            </div>
                            {!diag.childOnGroup && (
                                <div className="formControls">
                                <FormControlLabel
                                        labelPlacement="start"
                                    control={
                                            <Switch
                                                size="small"
                                            checked={state.autoLock}
                                                onChange={handleChange2} />
                                    }
                                    label="Auto lock relevant boards on timer expiry"
                                />
                                </div>
                            )}
                        </form>

                    </div>
                </DialogContent>
            </Dialog>
        )
    }
    function toggleTimer(e) {
        // if (!teacherR && !(props.sess && props.sess.isGroup)) {
        //     return
        // }
        var childOnGroup = false
        if (!teacherR ) {
            childOnGroup = true
        }

        if (timer.running) return
        setDiag({ open: true, cb: gotTime, childOnGroup: childOnGroup });
        ReactGA.event({
            category: "Timer",
            action: "Clicked"
        });
        function gotTime(e, kind, msg) {
            if (!e || e === "") {
                return
            }
            setDiag({ open: false, cb: null });

            var luid = mylocalStorage.getItem('mystoreID');
            var which = childOnGroup ? props.sess.parentID : props.sess.Classroom
            kind = childOnGroup ? "hourGlass" : kind
            var event = which + "-" + luid
            var jj = { action: "Timer", session: props.sess.id, "Duration": e, kind: kind, msg: msg}
            var cmd = {
                id: event, ttl: props.sess.ttl,
                event: event, Classroom: props.sess.Classroom,
                type: "Timer", State: "Sent", Content: JSON.stringify(jj)
            }
            cmd['For'] = which
            //            if (assistanceRequest.studentAsked) cmd['State'] = "Done"
            ib.getClassroomEvent(event).then((r) => {
                const f = r.data.getClassroomEvent
                if (f) {
                    ib.updateClassroomEvent(cmd)
                } else {
                    ib.createClassroomEvent(cmd)
                }
            })
        }
    }
    function resetTimer() {
        if (!lastDuration || lastDuration === "") {
            return
        }
        setAlarmRing(p => false)
        var luid = mylocalStorage.getItem('mystoreID');

        var event = props.sess.Classroom + "-" + luid
        var jj = { action: "Timer", session: props.sess.id, "Duration": lastDuration }
        var cmd = {
            id: event, ttl: props.sess.ttl,
            event: event, Classroom: props.sess.Classroom,
            type: "Timer", State: "Sent", Content: JSON.stringify(jj)
        }
        cmd['For'] = props.sess.Classroom
        //            if (assistanceRequest.studentAsked) cmd['State'] = "Done"
        ib.getClassroomEvent(event).then((r) => {
            const f = r.data.getClassroomEvent
            if (f) {
                ib.updateClassroomEvent(cmd)
            } else {
                ib.createClassroomEvent(cmd)
            }
        })
    }

    React.useEffect(() => {
        var count = 0;
        if (Boolean(timer.running)) {
            count++;
        }
        if (Boolean(boardLocked.locked)) {
            count++;
        }
        if (pageLocked.locked) {
            count++;
        }
        if (showCase.locked) {
            count++;
        }
        if (Boolean(followTeacher.set)) {
            count++;
        }
        setLengthOfNotifications(count)
        const openNext = Boolean(timer.running) || Boolean(boardLocked.locked) || pageLocked.locked || showCase.locked || Boolean(followTeacher.set)
        if (hideNotification && hideNotification === true) {
            setOpen(false)
            return
        }
        if (openNext && tpopperRef.current) {
            setOpen(true)
        }
        if (!openNext) setOpen(false)
        if (showCase.locked) {
            if (showCase && showCase.events && showCase.events.length > 0) {
                const content = showCase.events[0].Content
                if (content && content.state !== props.sess.id) {
                    // need to go to student page 
                    var jj = JSON.stringify({
                        sess: props.sess.parentBoardID,
                        class: props.sess.Classroom
                    })
                    mylocalStorage.setItem('showcaseRedir', jj) // store prev
                    if (!showCase.dialog) {
                        props.history.push("/board/" + content.state)
                    }
                }
            }
        } else {
            var redir = mylocalStorage.getItem('showcaseRedir');
            if (redir) {
                mylocalStorage.removeItem('showcaseRedir');
                let jj = JSON.parse(redir)
                // window.location.reload()
                if (jj && jj.class === props.sess.Classroom)
                    props.history.push("/join/" + jj.sess)

            }
        }
    }, [timer.running, hideNotification, boardLocked.locked, pageLocked.locked, showCase, tpopperRef, followTeacher.set])

    function dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id + "header")) {
            // if present, the header is where you move the DIV from:
            document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
        } else {
            // otherwise, move the DIV from anywhere inside the DIV:
            elmnt.onmousedown = dragMouseDown;
            elmnt.addEventListener('touchstart', (e) => dragMouseDown(e));
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            //   var rect = e.target.getBoundingClientRect()
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
            // if (e instanceof TouchEvent) {
            // Don't use instance of TouchEvent, it works on most browsers, fails on Safari.
            // Use e.touches, seems to work on everything.
            if (e.touches && e.touches.length === 1) {
                var touch = e.touches[0]
                touch.target.ontouchmove = elementDrag;
                touch.target.ontouchend = closeDragElement;
            }
        }
        
        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            var evt = e;
            if (e.touches && e.touches.length === 1) {
                var evt = e.touches[0]
            }
                let tempY = evt.clientY
                if (evt.clientY < 65 ){
                    tempY = 66
                }else if(evt.clientY > (window.innerHeight - 100) ){
                    tempY = (window.innerHeight - 100)
                }
                let tempX = evt.clientX;
                if (evt.clientX < 100 ){
                    tempX = 100
                }else if(evt.clientX > window.innerWidth - 150 ){
                    tempX = window.innerWidth - 150
                }
            pos1 = pos3 - tempX;
            pos2 = pos4 - tempY;
            elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            pos3 = tempX;
            pos4 = tempY;
            setElTop(p => elmnt.style.top);
            setElLeft(p => elmnt.style.left);
        }

        function closeDragElement(e) {
            // stop moving when mouse button is released:
            const timerLocation = { top: 0, left: 0 }
            setElTop(p => { timerLocation.top = p; return p })
            setElLeft(p => { timerLocation.left = p; return p })
            if (timerPanelMoved(timerLocation.top, timerLocation.left)) {
                mylocalStorage.setItem("timerLocation", JSON.stringify(timerLocation))
                try {
                    ReactGA.event({
                        category: "Timer",
                        action: "Relocated"
                    });
                } catch { }
                /* In case the user dragged using the timer icon, we don't want the
                   timer to be stopped */
                setStopTimerDebounce(p => true)
                setTimeout(() => { setStopTimerDebounce(p => false) }, 1000)
            }
            document.onmouseup = null;
            document.onmousemove = null;
            if (e.touches) {
                e.target.ontouchmove = null;
                e.target.ontouchend = null;
            }
        }
    }

    function timerPanelMoved(t, l) {
        var ret = true;
        const timerLocationStr = mylocalStorage.getItem("timerLocation");
        if (timerLocationStr && timerLocationStr !== undefined) {
            const timerLocation = JSON.parse(timerLocationStr);
            if (timerLocation && timerLocation.top && timerLocation.left) {
                if (timerLocation.top === t || timerLocation.left === l) {
                    ret = false;
                }
            }
        }
        return ret;
    }
    function clickMe () {
        if (Boolean(boardLocked.locked)) {
            unLockClass();
        }
        if (pageLocked.locked) {
            unLockPage();
        }
        if (showCase.locked) {
            showcaseRemove()
        }
        if (Boolean(followTeacher.set)) {
            unFollowTeacher();
        }
        if (Boolean(timer.running)) {
            {(timer.events).map((e) => (
                     stopTimer(e)
            ))}
        }
    }
    function renderList() {
        return (
            <div className={classes.paper} >
              <div className={classes.headerDots}>
                        <MoreHorizIcon
                            className={classes.dots} />
                    </div>
                <div className="notification">
                <List dense className={classes.list} >
                    {boardLocked.locked && (
                        <ListItem dense key={"boardLock"}>
                                <ListItemIcon>
                                    <img src={CorrectIcon} alt="Correct Icon" />
                            </ListItemIcon>
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={boardLocked.events[0] &&
                                    boardLocked.events[0].Content &&
                                    boardLocked.events[0].Content.bytimer ? "Board locked by timer"
                                    :
                                    "Board locked by teacher"} />
                                {Boolean(teacherR) && <ListItemIcon onClick={() => unLockClass()} onTouchEnd={() => unLockClass()}>
                                    <Button variant="contained" style={teacherStyle}>Disable</Button>
                                </ListItemIcon>}
                        </ListItem>
                    )}
                    {pageLocked.locked && (
                        <ListItem dense key={"pageLocked"}>
                                <ListItemIcon>
                                    <img src={CorrectIcon} alt="Correct Icon" />
                            </ListItemIcon>
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={"Page locked by teacher"} />
                                {Boolean(teacherR) && <ListItemIcon onClick={() => unLockPage()} onTouchEnd={() => unLockPage()}>
                                    <Button variant="contained" style={teacherStyle}>Disable</Button>
                                </ListItemIcon>}
                        </ListItem>
                    )}
                    {followTeacher.set && (
                        <ListItem dense key={"followTeacher"}>
                                <ListItemIcon>
                                    <img src={CorrectIcon} alt="Correct Icon" />
                            </ListItemIcon>
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={"Follow Teacher's Page"} />
                                {Boolean(teacherR) && <ListItemIcon onClick={() => unFollowTeacher()} onTouchEnd={() => unFollowTeacher()}>
                                    <Button variant="contained" style={teacherStyle}>Disable</Button>
                                </ListItemIcon>}
                        </ListItem>
                    )}
                    {showCase.locked && (
                        <ListItem dense key={"showCase"}>
                                <ListItemIcon>
                                    <img src={CorrectIcon} alt="Correct Icon" />
                                </ListItemIcon>
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={"Showcasing student board"} />
                                { Boolean(teacherR) ?
                                    <ListItemIcon onClick={() => showcaseRemove()} onTouchEnd={() => showcaseRemove()} style={{ cursor: Boolean(teacherR) ? "pointer" : "inherit" }}>
                                        <Button variant="contained" style={teacherStyle}>Disable</Button>
                                    </ListItemIcon> : null
                                }
                        </ListItem>
                    )}
                    {(timer.events).map((e) => (
                        <div key={e.id}>
                            <ListItem dense key={e.id}>
                                <ListItemIcon>
                                    <img src={CorrectIcon} alt="Correct Icon" />
                                </ListItemIcon>
                                <ListItemText style={{width: "fix-content"}}
                                    classes={{ primary: classes.listItemText }}
                                    primary={clock.timeLeft} secondary={e.Content.msg ? e.Content.msg + " "+clock.end : clock.end} />
                                {(Boolean(teacherR) || e.Content && e.Content.kind && e.Content.kind === "hourGlass") && (
                                    <ListItemIcon>
                                             <Button variant="contained"  onClick={() => stopTimer(e)} onTouchEnd={() => stopTimer(e)} style={teacherStyle}>Disable</Button>
                                    </ListItemIcon>
                                )}
                            </ListItem>
                            {e.Content && e.Content.kind && e.Content.kind === "hourGlass" && (
                                <Button size="small" className={classes.buttonReset} onClick={() => resetHourGlass(e)}  onTouchEnd={() => resetHourGlass(e)} style={{ backgroundColor: props.inkColor }}>Reset ({e.Content.Duration} min)</Button>
                            )}
                            { Boolean(teacherR) && clock.timeout && lastDuration !== "" ?
                                    <Button size="small" className={classes.buttonReset} onClick={() => resetTimer()}  onTouchEnd={() => resetTimer()} style={{ backgroundColor: props.inkColor }}>Reset ({lastDuration} min)</Button> : null}
                        </div>
                    ))}
                </List>
                    {lengthOfNotifications > 1 && Boolean(teacherR) && (
                        <div>
                            <Divider />
                            <span
                                onClick={clickMe}
                                onTouchEnd={() => clickMe()}
                                className={classes.disableAll}
                                style={{ backgroundColor: props.inkColor }}
                            >Disable all </span>
                        </div>
                    )

                    }
                </div>
            </div>
        )
    }
    const showAlarm = !boardConfig.fourToolsStudent || timer.running || Boolean(teacherR) || boardLocked.locked || pageLocked.locked || showCase.locked || Boolean(followTeacher.set) || (props.sess && props.sess.isGroup)
    return (
        <div>
            {showAlarm && (
                <Tooltip className={classes.tooltip}
                classes={{
                    tooltip: classes.customTooltip,
                    arrow: classes.customArrow
                }}
                title="Class Timers" arrow placement="top">
                <IconButton id="timerButton" ref={tpopperRef} className={clsx(classes.iconButtonHelp,'btnSqr')} style={{ color: props.inkColor }}
                    onClick={toggleTimer}>
                            <img src='/timer.svg' id="AlarmIcon" alt='timer icon' />
                </IconButton>
                </Tooltip>
            )}
            <GetTime />
            {
                (open) ?
                    <Paper key={1} id={'transitions-popper'} open={open} ref={popRef} className="notificationPopUp" >
                        {renderList()}
                    </Paper>
                    : null
            }
            { alarmRing ?
                <div className="vibratingClock">
                    <AlarmIcon style={{ fontSize: '3rem' }} />
                </div> : null}
        </div >
    )
}
export default React.memo(ClassTimer)